// extracted by mini-css-extract-plugin
export default {"backdrop":"WideModal_backdrop__JpGyx","modal":"WideModal_modal__WZfXs","modalAppear":"WideModal_modalAppear__LHeyx","closeButton":"WideModal_closeButton__KIr7K"};